var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as echarts from 'echarts';
var DataChart = (function (_super) {
    __extends(DataChart, _super);
    function DataChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataChart.prototype.initChart = function (xAxisData, seriesData) {
        var _this = this;
        this.timeout && clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            clearTimeout(_this.timeout);
            var options = {
                title: {
                    text: _this.title,
                    left: _this.titleLeft,
                    textStyle: {
                        fontSize: 16,
                        fontWeight: 500,
                        color: "#31394D",
                    },
                },
                tooltip: {
                    show: true,
                },
                legend: {
                    bottom: 10,
                },
                series: seriesData,
            };
            if (xAxisData) {
                options.xAxis = {
                    type: 'category',
                    data: xAxisData,
                };
                options.yAxis = {
                    type: 'value',
                };
            }
            console.log('chart-options:%o', options);
            _this.chart = echarts.init(_this.$refs.main);
            _this.chart.setOption(options);
        }, 300);
    };
    DataChart.prototype.beforeDestroy = function () {
        this.timeout && clearTimeout(this.timeout);
    };
    DataChart.prototype.mounted = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            if (_this.chart)
                _this.chart.resize();
        });
    };
    __decorate([
        Prop({
            default: '',
        })
    ], DataChart.prototype, "title", void 0);
    __decorate([
        Prop({
            default: 'auto',
        })
    ], DataChart.prototype, "titleLeft", void 0);
    DataChart = __decorate([
        Component
    ], DataChart);
    return DataChart;
}(Vue));
export default DataChart;
